import axiosInstance from "./axiosinstance";



export interface Invoice {
  id: string;
  customerId: string;
  customerName: string;
  location: string;
  type: string; 
  equipmentName: string;
  noOfVisit: number;
  kindlyAttend: string;
  reference: string;
  subject: string;
  plant: string;
  serviceAmount: number;
  supportAmount: number;
  createdBy: string;
  createdAt: string;
  modifiedAt: string;
  isDeleted: boolean;
}

export interface InvoiceForm {
  customerId: string;
  customerName: string;
  location: string;
  type: string;
  equipmentName: string;
  noOfVisit: number | "";
  kindlyAttend: string;
  reference: string;
  subject: string;
  plant: string;
  serviceAmount: number | "";
  supportAmount: number | "";
}

export interface InvoiceResponse {
  data: Invoice[];
  totalCount: number;
  totalPages?: number;
}

interface PaginatedInvoiceResponse extends Partial<InvoiceResponse> {
  items?: Invoice[];
  results?: Invoice[];
  total?: number;
  count?: number;
}

export const invoiceRepository = {

  getinvoice: async (
    pageNumber: number,
    pageSize: number,
    search: string = ""
  ): Promise<InvoiceResponse> => {
    const { data } = await axiosInstance.get<Invoice[] | PaginatedInvoiceResponse>(
      "/api/quotation",
      {
        params: { pageNumber, pageSize, search: search.trim() },
      }
    );

    if (Array.isArray(data)) {
      return { data, totalCount: data.length };
    }

    const items = data.data ?? data.items ?? data.results ?? [];
    const totalCount = data.totalCount ?? data.total ?? data.count ?? items.length;

    return {
      data: items,
      totalCount,
      totalPages: data.totalPages,
    };
  },

  getQuotationReport: async (
    id: string
  ): Promise<{ blob: Blob; fileName?: string }> => {
    const response = await axiosInstance.get<Blob>(
      `/api/quotation/${id}/quotation-report`,
      { responseType: "blob" }
    );
    const disposition = response.headers["content-disposition"] as string | undefined;
    const fileNameMatch = disposition?.match(/filename\*?=(?:UTF-8''|\")?([^;\"]+)/i);
    const fileName = fileNameMatch?.[1]
      ? decodeURIComponent(fileNameMatch[1].trim())
      : undefined;

    return { blob: response.data, fileName };
  },

  sendQuotationReportEmail: async (quotationId: string): Promise<void> => {
    await axiosInstance.post("/api/quotation/send-report-email", null, {
      params: {
        quotationId,
        type: "quotation",
      },
    });
  },

  // GET /api/quotation/{id}
  getbyid: async (id: string): Promise<Invoice> => {
    const { data } = await axiosInstance.get<Invoice>(`/api/quotation/${id}`);
    return data;
  },

  // GET /api/quotation/customer/{customerId}
  getbycustomer: async (customerId: string): Promise<Invoice[]> => {
    const { data } = await axiosInstance.get<Invoice[]>(
      `/api/quotation/customer/${customerId}`
    );
    return data;
  },

  // POST /api/quotation
  postinvoice: async (formData: Partial<Invoice>): Promise<Invoice> => {
    const { data } = await axiosInstance.post<Invoice>("/api/quotation", formData);
    return data;
  },

  // PUT /api/quotation/{id}
  updateinvoice: async (id: string, payload: Invoice): Promise<Invoice> => {
    const { data } = await axiosInstance.put<Invoice>(`/api/quotation/${id}`, payload);
    return data;
  },

  // DELETE /api/quotation/{id}
  deleteInvoice: async (id: string): Promise<void> => {
    await axiosInstance.delete(`/api/quotation/${id}`);
  },
};